<script>
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { formatImgUrl } from "src/filter/modules/img";
@Component({
  name: "estimated-cost-picture",
  components: {}
})
export default class App extends Vue {
  @Prop({ type: Object, default: () => ({}) }) info;

  mounted() {
  }
  render(h) {
    function setRateStyle(info) {
      if (info > 5.5) {
        return {
          backgroundColor: "white",
          color: "#333"
        };
      } else {
        return {
          backgroundColor: "#FF9999 !important",
          color: "white"
        };
      }
    }
    return (
      <div class="estimated-cost-picture">
        <div class="estimated-cost-picture__head">
          <p>
            {this.info.series}
            {this.info.productName}
            {this.info.waveCode}
          </p>
        </div>
        <div class="estimated-cost-picture__head__headMain">
          <div class="left">
            {this.info.productCategory}{" "}
            {this.info.projectType}
          </div>
          <div class="main">
            <img src={this.info.imgUrl} />
          </div>
          <div class="right"></div>
        </div>
        <div class="estimated-cost-picture__row bottom">
          <div>{this.info.tagPrice}</div>
          <div>{this.info.projectCost}</div>
          <div>{this.info.projectRate}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div style="background-color:#afdef9 !important">
            {this.info.temporaryMaterialCode}
          </div>
          <div>
            {this.info.costType}
            {this.info.cost}
          </div>
          <div style={setRateStyle(this.info.rate)}>{this.info.rate}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div>{this.info.officialMaterialCode}</div>
          <div>面料指导价</div>
          <div>{this.info.materialPrice}</div>
        </div>
        <div class="estimated-cost-picture__row">
          <div>{this.info.materialCode}</div>
          <div>{this.info.componentCode}</div>
          <div>{this.info.total}</div>
        </div>
        <div class="estimated-cost-picture__row height bottom">
          <div>{this.info.vendorName}</div>
          <div>{this.info.materialDesc}</div>
          <div>{this.info.referencePrice}</div>
        </div>
        <div class="estimated-cost-picture__row">{this.info.costStructure}</div>
        <div class="estimated-cost-picture__row">细节:{this.info.details}</div>
        <div class="estimated-cost-picture__row">附注:{this.info.remarks}</div>
      </div>
    );
  }
}
</script>

<style lang="scss" scope>
.estimated-cost-picture {
  border: 1px solid #333;
  width: 340px;
  height: 500px;
  overflow: hidden;
  & > .estimated-cost-picture__head {
    text-align: center;
    height: 25px;
  }

  & > .estimated-cost-picture__head__headMain {
    & > div {
      -webkit-print-color-adjust: exact;
    }
    padding-bottom: 10px;
    height: 250px;
    display: flex;
    & > .left {
      width: 20px;
      margin-left: 15px;
    }
    & > .main {
      width: 70%;
      overflow: hidden;
      text-align: center;
    }
    & > .right {
    }
    img {
      width: auto;
      height: 100%;
    }
  }

  & > .estimated-cost-picture__row {
    & > div {
      -webkit-print-color-adjust: exact;
    }
    &.bottom {
      border-bottom: 1px solid #999;
    }
    &.height {
      height: 50px;
    }
    height: 25px;
    display: flex;
    padding: 0 15px;
    & > div:nth-child(1) {
      width: calc(2 / 5 * 100%);
    }
    & > div:nth-child(2) {
      width: calc(2 / 5 * 100%);
    }
    & > div:nth-child(3) {
      width: calc(1 / 5 * 100%);
    }
  }
}
</style>